import React from 'react';
import {useFicha21} from "../../context/UserModulesContext";
import ClientControlCentral from "./ClientControlCentral";
import ClientMonitoring from "./ClientMonitoring";

/**
 * Decide qué pantalla es la ruta base /client/:id. La regla es la del tier de experiencia, no la
 * del rol: la ficha 2.1 abre en el Panel (lo mismo que /client/:id/control-central) y el Dashbo
 * clásico sigue abriendo en Monitoreo. Antes se resolvía con un fetch propio de
 * `get-logged-user-data/` mirando `is_super_admin`, que quedaba desalineado por los dos lados: un
 * superadmin que volvió al clásico veía el Panel igual, y un usuario de ficha 2.1 no-superadmin
 * caía en Monitoreo.
 *
 * Esperamos `loaded` antes de decidir (hasta que llega el payload `ficha21` es false): sin eso
 * rebotaríamos al usuario a la pantalla equivocada por un valor que todavía no llegó.
 *
 * Revert: restaurar el commit anterior de este archivo.
 */
export default function ClientDefaultRoute() {
    const {ficha21, loaded} = useFicha21();

    if (!loaded) {
        return null;
    }
    if (ficha21) {
        return <ClientControlCentral/>;
    }
    return <ClientMonitoring/>;
}
